import { IConfig } from '@cian/config/shared';

export const PRIVACY_POLICY_LINK = 'https://www.cian.ru/legal-documents/politika_konfidencialnosti_0/';
const PRIVACY_POLICY_CONFIG_KEY = 'newbuilding.privacyPolicyUrl';

export const getPrivacyPolicyUrl = (config: IConfig): string => {
  return config.get<string>(PRIVACY_POLICY_CONFIG_KEY) || PRIVACY_POLICY_LINK;
};
